module.exports = "<label *ngIf=\"labelSpace\" >&nbsp;</label>\r\n<div>\r\n<label >{{titolo}}</label>\r\n<label class=\"switch\">        \r\n        <input type=\"checkbox\" \r\n        [ngModel]=\"innerValue\"\r\n        (ngModelChange)=\"innerValueChange($event)\" \r\n        [disabled]=\"disabled  ? 'disabled':null\"\r\n        [readOnly]=\"readOnly  ? 'readOnly':null\"         \r\n        >\r\n        <span class=\"slider round\"></span>\r\n</label>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/angular_library/components/checkbox/checkbox.html
// module id = ./src/angular_library/components/checkbox/checkbox.html
// module chunks = main